import React from 'react'

import Button from 'components/common/Button'
import Image from 'components/common/Image'
import theme from 'theme'

export const SSOButton: React.FC<{
  alt: string
  onClick(): void
  logo: string
  text: string
  disabled: boolean
}> = ({ alt, onClick, text, logo, disabled = false, ...rest }) => {
  return (
    <Button
      secondary
      stretch
      css={{ marginBottom: theme.space[3] }}
      disabled={disabled}
      label={text}
      type="button"
      onClick={onClick}
      {...rest}
    >
      <span
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Image
          data-test-ssobutton-image
          alt={alt}
          css={{ marginRight: theme.space[2], height: theme.space[4] }}
          src={logo}
        />
        {text}
      </span>
    </Button>
  )
}
